// Used for testing purposes only
export default function getFakeData(urlInfo) {
  window.console.log(
    'Using mock search data for testing. Requested search URL: ',
    urlInfo,
  );
  function isSelected(id) {
    return urlInfo.indexOf(id) !== -1;
  }
  function getParameterByName(aName) {
    const url = urlInfo;
    const name = aName.replace(/[[\]]/g, '\\$&');
    const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
    const results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }
  // replace regex: (Udi: 'umb://document/)([a-f0-9]+)(',\s+\r*\n*\s+IsSelected: )false
  // with: $1$2$3IsSelected('$2')
  function shuffle(a) {
    for (let i = a.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      // eslint-disable-next-line no-param-reassign
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  }
  function randint(max) {
    return Math.floor(Math.random() * max + 1);
  }

  function getDefaultMockData() {
    return {
      Data: shuffle([
        {
          Id: '1',
          Title: 'Using the calculator',
          Url: '#',
          Description:
            'Nunc quis massa vitae neque tempus eleifend. Etiam at nisi rhoncus, aliquet elit.',
          ContentType: 'Event',
          Date: '11 October 2020',
          DateMonth: 'Oct',
          DateDay: '11',
          ImageUrl: '/dist/images/demo.jpg?mode=crop',
          PublishAge: '1 year ago',
          Locations: 'The Spice Building, 8 Devonshire Square, London',
          Tags: 'Contracts, Pay, Event',
          Audience: 'Consultants',
          Author: 'John Doe',
          Duration: '6 hours',
          EventFormat: 'Webinar',
          IconUrl: '/dist/images/play.svg',
          Price: '£15',
          Time: '12.45PM - 6.45PM',
        },
        {
          Id: '2',
          Title: 'Here is a Title of a Search Result ',
          Url: '#',
          Description:
            'Nunc quis massa vitae neque tempus eleifend. Etiam at nisi rhoncus, aliquet elit.',
          ContentType: 'Article',
          Date: 'Monday 28 September 2020',
          DateMonth: 'Sep',
          DateDay: '28',
          ImageUrl: '/dist/images/demo.jpg?mode=crop',
          PublishAge: '11 months ago',
          Locations: 'Online',
          Tags: 'England, Nurses',
          Audience: 'Nurses',
          Author: 'John Doe',
          Duration: '3 hours',
          EventFormat: 'E-learning',
          IconUrl: '/dist/images/e-learning.svg',
          Price: 'Free',
          Time: '12.45PM - 6.45PM',
        },
        {
          Id: '3',
          Title: 'Here is a Title of a Search Result ',
          Url: '#',
          Description:
            'Nunc quis massa vitae neque tempus eleifend. Etiam at nisi rhoncus, aliquet elit.',
          ContentType: 'Event',
          Date: 'Tuesday 25 October 2020',
          DateMonth: 'Oct',
          DateDay: '25',
          ImageUrl: '/dist/images/demo.jpg?mode=crop',
          PublishAge: '10 months ago',
          Locations: 'Location',
          Tags: 'England, Nurses, Event',
        },
        {
          Id: '4',
          Title: 'This title links to an event',
          Url: '#',
          Description:
            'Nunc quis massa vitae neque tempus eleifend. Etiam at nisi rhoncus, aliquet elit.',
          ContentType: 'Article',
          Date: 'Wednesday 1 October 2020',
          DateMonth: 'Oct',
          DateDay: '1',
          Author: 'John Doe',
          ImageUrl: '/dist/images/demo.jpg?mode=crop',
          PublishAge: '9 months ago',
          Locations: 'The Spice Building, 8 Devonshire Square, London',
          Tags: 'England, Contracts, Event',
        },
        {
          Id: '5',
          Title: 'Toolkit details 4',
          Url: '#',
          Description:
            'Nunc quis massa vitae neque tempus eleifend. Etiam at nisi rhoncus, aliquet elit.',
          ContentType: 'Event',
          Date: 'Monday 3 August 2020',
          DateMonth: 'Aug',
          DateDay: '3',
          Author: 'John Doe',
          ImageUrl: '/dist/images/demo.jpg?mode=crop',
          PublishAge: '3 weeks ago',
          Locations: 'The Spice Building, 8 Devonshire Square, London',
          Tags: 'Nurses, Contracts, Event',
        },
      ]),
      Pagination: {
        Total: 45 - urlInfo.split('=').length,
        CurrentPage: getParameterByName('pageNumber') || 1,
        PageSize: 5,
        TotalNumberOfPages: 9,
        BaseUrl: '/umbraco/Surface/Search/DoSearch?query=test&pageSize=5',
        ResultsPageUrl: null,
      },
      FacetResult: {
        Facets: [
          {
            FacetName: 'Topics',
            FacetAlias: 'topics',
            IsPrimaryFacet: true,
            FacetResults: [
              {
                Count: 13,
                Name: 'Contracts',
                Udi: 'umb://document/27f3344f7ee54faa838401d64fb0d4db',
                IsSelected: isSelected('27f3344f7ee54faa838401d64fb0d4db'),
              },
              {
                Count: 5,
                Name: 'Pay',
                Udi: 'umb://document/53cf88c0752945b8a84316885ced2bf1',
                IsSelected: isSelected('53cf88c0752945b8a84316885ced2bf1'),
              },
              {
                Count: 6,
                Name: 'Negotiations',
                Udi: 'umb://document/5aec03cef36e4363a87f2ddfb0131288',
                IsSelected: isSelected('5aec03cef36e4363a87f2ddfb0131288'),
              },
              {
                Count: 4,
                Name: 'Junior agent contract',
                Udi: 'umb://document/1a3636fa32754d9aa8d1dc03d53755a8',
                IsSelected: isSelected('1a3636fa32754d9aa8d1dc03d53755a8'),
              },
            ],
          },
          {
            FacetName: 'Audience',
            FacetAlias: 'audience',
            FacetResults: [
              {
                Count: 2,
                Name: 'Students',
                Udi: 'umb://document/ef2a16b6c7ff4b459b74f5e897578d49',
                IsSelected: isSelected('ef2a16b6c7ff4b459b74f5e897578d49'),
              },
              {
                Count: 9,
                Name: 'Consultants',
                Udi: 'umb://document/4402b35062ed4cdcad6824c10fe7e425',
                IsSelected: isSelected('4402b35062ed4cdcad6824c10fe7e425'),
              },
              {
                Count: 3,
                Name: 'Investors',
                Udi: 'umb://document/991d7e8ef43b4c46b62592b91617a524',
                IsSelected: isSelected('991d7e8ef43b4c46b62592b91617a524'),
              },
            ],
          },
          {
            FacetName: 'Content Type',
            FacetAlias: 'ContentType',
            FacetResults: [
              {
                Count: 6,
                Name: 'Type A',
                Udi: 'umb://document/53c3063848ff4695a9e0ec9676472acc',
                IsSelected: isSelected('53c3063848ff4695a9e0ec9676472acc'),
              },
              {
                Count: 3,
                Name: 'Type B',
                Udi: 'umb://document/1b4545b1e4fb4838af678c73eed5a4a4',
                IsSelected: isSelected('1b4545b1e4fb4838af678c73eed5a4a4'),
              },
              {
                Count: 1,
                Name: 'Type C',
                Udi: 'umb://document/19e2a989806a40b1845aa66dafce7177',
                IsSelected: isSelected('19e2a989806a40b1845aa66dafce7177'),
              },
              {
                Count: 0,
                Name: 'Type D',
                Udi: 'umb://document/52d1995a7df14967a277c1a373cd6249',
                IsSelected: isSelected('52d1995a7df14967a277c1a373cd6249'),
              },
              {
                Count: 0,
                Name: 'Type E',
                Udi: 'umb://document/772269d1ad5147458a9e3290ed432xx1',
                IsSelected: isSelected('772269d1ad5147458a9e3290ed432xx1'),
              },
              {
                Count: 0,
                Name: 'Type F',
                Udi: 'umb://document/772269d1ad5147458a9e3290ed432xx2',
                IsSelected: isSelected('772269d1ad5147458a9e3290ed432xx2'),
              },
            ],
          },
          {
            FacetName: 'Type',
            FacetAlias: 'nations',
            IsAuxilaryFacet: true,
            FacetResults: [
              {
                Count: 2,
                Name: 'Type G',
                Udi: 'umb://document/772269d1ad5147458a9e3290ed4320ac',
                IsSelected: isSelected('772269d1ad5147458a9e3290ed4320ac'),
              },
              {
                Count: 1,
                Name: 'Type H',
                Udi: 'umb://document/ae341434e4a84249831ad2ca05705321',
                IsSelected: isSelected('ae341434e4a84249831ad2ca05705321'),
              },
              {
                Count: 3,
                Name: 'Type I',
                Udi: 'umb://document/b5a22c3a9d4846f08d6dad9a8cbcec67',
                IsSelected: isSelected('b5a22c3a9d4846f08d6dad9a8cbcec67'),
              },
              {
                Count: 0,
                Name: 'Type J',
                Udi: 'umb://document/c149c428094c4c3cbf2f77786cec1e74',
                IsSelected: isSelected('c149c428094c4c3cbf2f77786cec1e74'),
              },
            ].filter(
              x => !isSelected('b5a22c3a9d4846f08d6dad9a8cbcec67')
                || !/ae341434e4a84249831ad2ca05705321/.test(x.Udi),
            ),
          },
          {
            FacetName: 'Hidden field',
            FacetAlias: 'hiddenField',
            IsAuxilaryFacet: true,
            Hidden: true,
            FacetResults: [
              {
                Count: 2,
                Name: 'Test 1',
                Udi: 'umb://document/67566269d1ad5147458a9e3290ed4320ac',
                IsSelected: isSelected('67566269d1ad5147458a9e3290ed4320ac'),
              },
              {
                Count: 1,
                Name: 'Test 2',
                Udi: 'umb://document/567434e4a84249831ad2ca05705321',
                IsSelected: isSelected('567434e4a84249831ad2ca05705321'),
              },
              {
                Count: 3,
                Name: 'Test 3',
                Udi: 'umb://document/3452c3a9d4846f08d6dad9a8cbcec67',
                IsSelected: isSelected('3452c3a9d4846f08d6dad9a8cbcec67'),
              },
              {
                Count: 0,
                Name: 'Test 4',
                Udi: 'umb://document/6869c428094c4c3cbf2f77786cec1e74',
                IsSelected: isSelected('6869c428094c4c3cbf2f77786cec1e74'),
              },
            ],
          },
        ],
      },
      SearchQuery: 'searched term',
      IsSuccess: true,
      ErrorMessage: null,
    };
  }

  function getLiteratureListingMockData() {
    return {
      Data: [
        {
          Id: '1',
          Title: 'Aenean posuere tortor sed cursus',
          Description: '',
          Url: '/media/ow0lkuqi/7im-offshore-model-portfolios-adventurous.pdf',
          Image: null,
          SearchTileImage: null,
          NodeId: 1357,
          Language: null,
          PublishDate: '0001-01-01T00:00:00',
          PublishDateString: null,
          Authors: null,
          AuthorTags: null,
          DocumentTypeTags: [
            {
              Key: '1350:en-us',
              ExpandOnClient: true,
              ViewModel: {
                Id: 1350,
                TagLabel: 'Sales Aid',
                Source: null,
                ActiveFrom: '0001-01-01T00:00:00',
                ActiveTo: '9999-12-31T23:59:59.9999999',
              },
            },
            {
              Key: '1351:en-us',
              ExpandOnClient: true,
              ViewModel: {
                Id: 1351,
                TagLabel: 'Holdings',
                Source: null,
                ActiveFrom: '0001-01-01T00:00:00',
                ActiveTo: '9999-12-31T23:59:59.9999999',
              },
            },
          ],
          LiteratureServiceTags: [
            {
              Key: '1352:en-us',
              ExpandOnClient: true,
              ViewModel: {
                Id: 1352,
                TagLabel: 'Fusion',
                Source: null,
                ActiveFrom: '0001-01-01T00:00:00',
                ActiveTo: '9999-12-31T23:59:59.9999999',
              },
            },
          ],
          ModelType: null,
          Location: null,
          DocumentTypeAlias: 'literatureItem',
          Platform: null,
          JobRole: '',
          ProfileTelephone: '',
          ProfileEmail: '',
          EventStartMoth: null,
          EventStartDateDay: null,
          EventTime: null,
          EventStartDate: '0001-01-01T00:00:00',
          EventTypes: null,
          HideLinkToEntity: false,
          ActiveFrom: '0001-01-01T00:00:00',
          ActiveTo: '9999-12-31T23:59:59.9999999',
        },
        {
          Id: '2',
          Title: 'Aenean vulputate',
          Description: '',
          Url: '/media/2lphp3cd/scott-graham-5fnmwej4taa-unsplash.jpg',
          Image: null,
          SearchTileImage: null,
          NodeId: 1362,
          Language: null,
          PublishDate: '0001-01-01T00:00:00',
          PublishDateString: null,
          Authors: null,
          AuthorTags: null,
          DocumentTypeTags: [
            {
              Key: '1349:en-us',
              ExpandOnClient: true,
              ViewModel: {
                Id: 1349,
                TagLabel: 'Prospectus',
                Source: null,
                ActiveFrom: '0001-01-01T00:00:00',
                ActiveTo: '9999-12-31T23:59:59.9999999',
              },
            },
            {
              Key: '1350:en-us',
              ExpandOnClient: true,
              ViewModel: {
                Id: 1350,
                TagLabel: 'Sales Aid',
                Source: null,
                ActiveFrom: '0001-01-01T00:00:00',
                ActiveTo: '9999-12-31T23:59:59.9999999',
              },
            },
            {
              Key: '1348:en-us',
              ExpandOnClient: true,
              ViewModel: {
                Id: 1348,
                TagLabel: 'Tax reports',
                Source: null,
                ActiveFrom: '0001-01-01T00:00:00',
                ActiveTo: '9999-12-31T23:59:59.9999999',
              },
            },
          ],
          LiteratureServiceTags: [
            {
              Key: '1352:en-us',
              ExpandOnClient: true,
              ViewModel: {
                Id: 1352,
                TagLabel: 'Fusion',
                Source: null,
                ActiveFrom: '0001-01-01T00:00:00',
                ActiveTo: '9999-12-31T23:59:59.9999999',
              },
            },
            {
              Key: '1355:en-us',
              ExpandOnClient: true,
              ViewModel: {
                Id: 1355,
                TagLabel: 'Novia',
                Source: null,
                ActiveFrom: '0001-01-01T00:00:00',
                ActiveTo: '9999-12-31T23:59:59.9999999',
              },
            },
            {
              Key: '1354:en-us',
              ExpandOnClient: true,
              ViewModel: {
                Id: 1354,
                TagLabel: 'Succession',
                Source: null,
                ActiveFrom: '0001-01-01T00:00:00',
                ActiveTo: '9999-12-31T23:59:59.9999999',
              },
            },
          ],
          ModelType: null,
          Location: null,
          DocumentTypeAlias: 'literatureItem',
          Platform: null,
          JobRole: '',
          ProfileTelephone: '',
          ProfileEmail: '',
          EventStartMoth: null,
          EventStartDateDay: null,
          EventTime: null,
          EventStartDate: '0001-01-01T00:00:00',
          EventTypes: null,
          HideLinkToEntity: false,
          ActiveFrom: '0001-01-01T00:00:00',
          ActiveTo: '9999-12-31T23:59:59.9999999',
        },
        {
          Id: '3',
          Title: 'Aenean vulputate eleifend tellus',
          Description: '',
          Url: '/media/2lphp3cd/scott-graham-5fnmwej4taa-unsplash.jpg',
          Image: null,
          SearchTileImage: null,
          NodeId: 1359,
          Language: null,
          PublishDate: '0001-01-01T00:00:00',
          PublishDateString: null,
          Authors: null,
          AuthorTags: null,
          DocumentTypeTags: [
            {
              Key: '1349:en-us',
              ExpandOnClient: true,
              ViewModel: {
                Id: 1349,
                TagLabel: 'Prospectus',
                Source: null,
                ActiveFrom: '0001-01-01T00:00:00',
                ActiveTo: '9999-12-31T23:59:59.9999999',
              },
            },
            {
              Key: '1350:en-us',
              ExpandOnClient: true,
              ViewModel: {
                Id: 1350,
                TagLabel: 'Sales Aid',
                Source: null,
                ActiveFrom: '0001-01-01T00:00:00',
                ActiveTo: '9999-12-31T23:59:59.9999999',
              },
            },
            {
              Key: '1351:en-us',
              ExpandOnClient: true,
              ViewModel: {
                Id: 1351,
                TagLabel: 'Holdings',
                Source: null,
                ActiveFrom: '0001-01-01T00:00:00',
                ActiveTo: '9999-12-31T23:59:59.9999999',
              },
            },
            {
              Key: '1348:en-us',
              ExpandOnClient: true,
              ViewModel: {
                Id: 1348,
                TagLabel: 'Tax reports',
                Source: null,
                ActiveFrom: '0001-01-01T00:00:00',
                ActiveTo: '9999-12-31T23:59:59.9999999',
              },
            },
          ],
          LiteratureServiceTags: [
            {
              Key: '1352:en-us',
              ExpandOnClient: true,
              ViewModel: {
                Id: 1352,
                TagLabel: 'Fusion',
                Source: null,
                ActiveFrom: '0001-01-01T00:00:00',
                ActiveTo: '9999-12-31T23:59:59.9999999',
              },
            },
            {
              Key: '1216:en-us',
              ExpandOnClient: true,
              ViewModel: {
                Id: 1216,
                TagLabel: ' Transact',
                Source: null,
                ActiveFrom: '0001-01-01T00:00:00',
                ActiveTo: '9999-12-31T23:59:59.9999999',
              },
            },
            {
              Key: '1155:en-us',
              ExpandOnClient: true,
              ViewModel: {
                Id: 1155,
                TagLabel: 'Offshore',
                Source: null,
                ActiveFrom: '0001-01-01T00:00:00',
                ActiveTo: '9999-12-31T23:59:59.9999999',
              },
            },
            {
              Key: '1355:en-us',
              ExpandOnClient: true,
              ViewModel: {
                Id: 1355,
                TagLabel: 'Novia',
                Source: null,
                ActiveFrom: '0001-01-01T00:00:00',
                ActiveTo: '9999-12-31T23:59:59.9999999',
              },
            },
            {
              Key: '1354:en-us',
              ExpandOnClient: true,
              ViewModel: {
                Id: 1354,
                TagLabel: 'Succession',
                Source: null,
                ActiveFrom: '0001-01-01T00:00:00',
                ActiveTo: '9999-12-31T23:59:59.9999999',
              },
            },
          ],
          ModelType: null,
          Location: null,
          DocumentTypeAlias: 'literatureItem',
          Platform: null,
          JobRole: '',
          ProfileTelephone: '',
          ProfileEmail: '',
          EventStartMoth: null,
          EventStartDateDay: null,
          EventTime: null,
          EventStartDate: '0001-01-01T00:00:00',
          EventTypes: null,
          HideLinkToEntity: false,
          ActiveFrom: '0001-01-01T00:00:00',
          ActiveTo: '9999-12-31T23:59:59.9999999',
        },
        {
          Id: '4',
          Title: 'Donec orci lectus aliquam ut',
          Description: '',
          Url: '/media/0xqcndis/timon-studler-abgavhjxwdq-unsplash.jpg',
          Image: null,
          SearchTileImage: null,
          NodeId: 1360,
          Language: null,
          PublishDate: '0001-01-01T00:00:00',
          PublishDateString: null,
          Authors: null,
          AuthorTags: null,
          DocumentTypeTags: [
            {
              Key: '1351:en-us',
              ExpandOnClient: true,
              ViewModel: {
                Id: 1351,
                TagLabel: 'Holdings',
                Source: null,
                ActiveFrom: '0001-01-01T00:00:00',
                ActiveTo: '9999-12-31T23:59:59.9999999',
              },
            },
          ],
          LiteratureServiceTags: [
            {
              Key: '1216:en-us',
              ExpandOnClient: true,
              ViewModel: {
                Id: 1216,
                TagLabel: ' Transact',
                Source: null,
                ActiveFrom: '0001-01-01T00:00:00',
                ActiveTo: '9999-12-31T23:59:59.9999999',
              },
            },
            {
              Key: '1352:en-us',
              ExpandOnClient: true,
              ViewModel: {
                Id: 1352,
                TagLabel: 'Fusion',
                Source: null,
                ActiveFrom: '0001-01-01T00:00:00',
                ActiveTo: '9999-12-31T23:59:59.9999999',
              },
            },
            {
              Key: '1353:en-us',
              ExpandOnClient: true,
              ViewModel: {
                Id: 1353,
                TagLabel: 'Ascentic',
                Source: null,
                ActiveFrom: '0001-01-01T00:00:00',
                ActiveTo: '9999-12-31T23:59:59.9999999',
              },
            },
          ],
          ModelType: null,
          Location: null,
          DocumentTypeAlias: 'literatureItem',
          Platform: null,
          JobRole: '',
          ProfileTelephone: '',
          ProfileEmail: '',
          EventStartMoth: null,
          EventStartDateDay: null,
          EventTime: null,
          EventStartDate: '0001-01-01T00:00:00',
          EventTypes: null,
          HideLinkToEntity: false,
          ActiveFrom: '0001-01-01T00:00:00',
          ActiveTo: '9999-12-31T23:59:59.9999999',
        },
        {
          Id: '5',
          Title: 'hellooo',
          Description: '',
          Url: '/media/2lphp3cd/scott-graham-5fnmwej4taa-unsplash.jpg',
          Image: null,
          SearchTileImage: null,
          NodeId: 1365,
          Language: null,
          PublishDate: '0001-01-01T00:00:00',
          PublishDateString: null,
          Authors: null,
          AuthorTags: null,
          DocumentTypeTags: [
            {
              Key: '1349:en-us',
              ExpandOnClient: true,
              ViewModel: {
                Id: 1349,
                TagLabel: 'Prospectus',
                Source: null,
                ActiveFrom: '0001-01-01T00:00:00',
                ActiveTo: '9999-12-31T23:59:59.9999999',
              },
            },
            {
              Key: '1350:en-us',
              ExpandOnClient: true,
              ViewModel: {
                Id: 1350,
                TagLabel: 'Sales Aid',
                Source: null,
                ActiveFrom: '0001-01-01T00:00:00',
                ActiveTo: '9999-12-31T23:59:59.9999999',
              },
            },
          ],
          LiteratureServiceTags: [
            {
              Key: '1352:en-us',
              ExpandOnClient: true,
              ViewModel: {
                Id: 1352,
                TagLabel: 'Fusion',
                Source: null,
                ActiveFrom: '0001-01-01T00:00:00',
                ActiveTo: '9999-12-31T23:59:59.9999999',
              },
            },
            {
              Key: '1355:en-us',
              ExpandOnClient: true,
              ViewModel: {
                Id: 1355,
                TagLabel: 'Novia',
                Source: null,
                ActiveFrom: '0001-01-01T00:00:00',
                ActiveTo: '9999-12-31T23:59:59.9999999',
              },
            },
            {
              Key: '1354:en-us',
              ExpandOnClient: true,
              ViewModel: {
                Id: 1354,
                TagLabel: 'Succession',
                Source: null,
                ActiveFrom: '0001-01-01T00:00:00',
                ActiveTo: '9999-12-31T23:59:59.9999999',
              },
            },
          ],
          ModelType: null,
          Location: null,
          DocumentTypeAlias: 'literatureItem',
          Platform: null,
          JobRole: '',
          ProfileTelephone: '',
          ProfileEmail: '',
          EventStartMoth: null,
          EventStartDateDay: null,
          EventTime: null,
          EventStartDate: '0001-01-01T00:00:00',
          EventTypes: null,
          HideLinkToEntity: false,
          ActiveFrom: '0001-01-01T00:00:00',
          ActiveTo: '9999-12-31T23:59:59.9999999',
        },
      ],
      Pagination: {
        Total: 5,
        CurrentPage: 1,
        PageSize: 10,
        TotalNumberOfPages: null,
        SiteId: '1212',
        BaseUrl: '/api/filtering/do?siteId=1212&contentType=literatureItem',
        ResultsPageUrl: null,
      },
      FacetResult: {
        Facets: [
          {
            FacetName: 'Service',
            FacetAlias: 'literatureServiceGroup',
            Hidden: false,
            IsAuxilaryFacet: false,
            FacetResults: [
              {
                Count: 5,
                Name: 'Fusion',
                Udi: '1352',
                IsSelected: true,
                Hidden: false,
              },
              {
                Count: 3,
                Name: 'Succession',
                Udi: '1354',
                IsSelected: false,
                Hidden: false,
              },
              {
                Count: 3,
                Name: 'Novia',
                Udi: '1355',
                IsSelected: false,
                Hidden: false,
              },
              {
                Count: 2,
                Name: ' Transact',
                Udi: '1216',
                IsSelected: false,
                Hidden: false,
              },
              {
                Count: 1,
                Name: 'Offshore',
                Udi: '1155',
                IsSelected: false,
                Hidden: false,
              },
              {
                Count: 1,
                Name: 'Ascentic',
                Udi: '1353',
                IsSelected: false,
                Hidden: false,
              },
            ],
          },
          {
            FacetName: 'Document Type',
            FacetAlias: 'literatureDocumentTypeGroup',
            Hidden: false,
            IsAuxilaryFacet: false,
            FacetResults: [
              {
                Count: 4,
                Name: 'Sales Aid',
                Udi: '1350',
                IsSelected: false,
                Hidden: false,
              },
              {
                Count: 3,
                Name: 'Prospectus',
                Udi: '1349',
                IsSelected: false,
                Hidden: false,
              },
              {
                Count: 3,
                Name: 'Holdings',
                Udi: '1351',
                IsSelected: false,
                Hidden: false,
              },
              {
                Count: 2,
                Name: 'Tax reports',
                Udi: '1348',
                IsSelected: false,
                Hidden: false,
              },
            ],
          },
        ],
      },
      SearchQuery: null,
      OrderBy: null,
      OrderType: 0,
      IsSuccess: false,
      ErrorMessage: null,
      Total: 0,
      Page: 0,
      SearchModels: [
        {
          IndexedAt: '2020-12-02T09:08:06',
          Culture: 'en-US',
          ContentKey: '1357:en-us:searchtile',
          Content: null,
          Tags: [],
          ContentType: null,
          ViewModelType: null,
          CustomProperties: {},
        },
        {
          IndexedAt: '2020-12-02T09:08:17',
          Culture: 'en-US',
          ContentKey: '1359:en-us:searchtile',
          Content: null,
          Tags: [],
          ContentType: null,
          ViewModelType: null,
          CustomProperties: {},
        },
        {
          IndexedAt: '2020-12-02T09:08:23',
          Culture: 'en-US',
          ContentKey: '1360:en-us:searchtile',
          Content: null,
          Tags: [],
          ContentType: null,
          ViewModelType: null,
          CustomProperties: {},
        },
        {
          IndexedAt: '2020-12-02T09:08:34',
          Culture: 'en-US',
          ContentKey: '1362:en-us:searchtile',
          Content: null,
          Tags: [],
          ContentType: null,
          ViewModelType: null,
          CustomProperties: {},
        },
        {
          IndexedAt: '2020-12-02T09:08:51',
          Culture: 'en-US',
          ContentKey: '1365:en-us:searchtile',
          Content: null,
          Tags: [],
          ContentType: null,
          ViewModelType: null,
          CustomProperties: {},
        },
      ],
    };
  }

  function getServiceListingMockData() {
    return {
      Data: shuffle([
        {
          Id: '1',
          Title: 'Sample title',
          Url: '#',
          ServiceType: 'Pathway',
          PlatformTag: '7IM Platform',
          DocumentTypeTag: 'Factsheet',
        },
        {
          Id: '2',
          Title: 'Sample title',
          Url: '#',
          ServiceType: 'Pathway',
          PlatformTag: 'Aviva',
          DocumentTypeTag: 'Holdings',
        },
        {
          Id: '3',
          Title: 'Sample title',
          Url: '#',
          ServiceType: 'Pathway',
          PlatformTag: 'Novia',
          DocumentTypeTag: 'Terms of Business',
        },
        {
          Id: '4',
          Title: 'Sample title',
          Url: '#',
          ServiceType: 'Active',
          PlatformTag: '7IM Platform',
          DocumentTypeTag: 'Factsheet',
        },
        {
          Id: '5',
          Title: 'Sample title',
          Url: '#',
          ServiceType: 'Active',
          PlatformTag: 'Novia',
          DocumentTypeTag: 'Holdings',
        },
        {
          Id: '6',
          Title: 'Sample document for download',
          Url: '#',
          ServiceType: 'Active',
          PlatformTag: 'Aviva',
          DocumentTypeTag: 'Terms of Business',
        },
        {
          Id: '7',
          Title: 'Sample title',
          Url: '#',
          ServiceType: 'Active',
          PlatformTag: '7IM Platform',
          DocumentTypeTag: 'Factsheet',
        },
        {
          Id: '8',
          Title: 'Sample download',
          Url: '#',
          ServiceType: 'Passive',
          PlatformTag: 'Novia',
          DocumentTypeTag: 'Holdings',
        },
        {
          Id: '9',
          Title: 'Sample title',
          Url: '#',
          ServiceType: 'Passive',
          PlatformTag: 'Aviva',
          DocumentTypeTag: 'Terms of Business',
        },
        {
          Id: '10',
          Title: 'Sample document',
          Url: '#',
          ServiceType: 'Passive',
          PlatformTag: 'Novia',
          DocumentTypeTag: 'Terms of Business',
        },
      ]),
      Pagination: {
        Total: 45 - urlInfo.split('=').length,
        CurrentPage: getParameterByName('pageNumber') || 1,
        PageSize: 5,
        TotalNumberOfPages: 9,
        BaseUrl: '/umbraco/Surface/ServiceListing/DoSearch?pageSize=5',
      },
      FacetResult: {
        Facets: [
          {
            FacetName: 'Service Name',
            FacetAlias: 'modelName',
            IsPrimaryFacet: true,
            FacetResults: [
              {
                Count: 13,
                Name: 'Service A',
                Udi: 'umb://document/27f3344f7ee54faa838401d64fb0d4db',
                IsSelected: isSelected('27f3344f7ee54faa838401d64fb0d4db'),
              },
              {
                Count: 5,
                Name: 'Service B',
                Udi: 'umb://document/53cf88c0752945b8a84316885ced2bf1',
                IsSelected: isSelected('53cf88c0752945b8a84316885ced2bf1'),
              },
              {
                Count: 6,
                Name: 'Service C',
                Udi: 'umb://document/5aec03cef36e4363a87f2ddfb0131288',
                IsSelected: isSelected('5aec03cef36e4363a87f2ddfb0131288'),
              },
              {
                Count: 4,
                Name: 'Service D',
                Udi: 'umb://document/1a3636fa32754d9aa8d1dc03d53755a8',
                IsSelected: isSelected('1a3636fa32754d9aa8d1dc03d53755a8'),
              },
            ],
          },
          {
            FacetName: 'Document Type',
            FacetAlias: 'documentType',
            FacetResults: [
              {
                Count: 6,
                Name: 'Type A',
                Udi: 'umb://document/53c3063848ff4695a9e0ec9676472acc',
                IsSelected: isSelected('53c3063848ff4695a9e0ec9676472acc'),
              },
              {
                Count: 3,
                Name: 'Type B',
                Udi: 'umb://document/1b4545b1e4fb4838af678c73eed5a4a4',
                IsSelected: isSelected('1b4545b1e4fb4838af678c73eed5a4a4'),
              },
              {
                Count: 1,
                Name: 'Type C',
                Udi: 'umb://document/19e2a989806a40b1845aa66dafce7177',
                IsSelected: isSelected('19e2a989806a40b1845aa66dafce7177'),
              },
              {
                Count: 0,
                Name: 'Type D',
                Udi: 'umb://document/52d1995a7df14967a277c1a373cd6249',
                IsSelected: isSelected('52d1995a7df14967a277c1a373cd6249'),
              },
              {
                Count: 0,
                Name: 'Type E',
                Udi: 'umb://document/772269d1ad5147458a9e3290ed432xx1',
                IsSelected: isSelected('772269d1ad5147458a9e3290ed432xx1'),
              },
              {
                Count: 0,
                Name: 'Type F',
                Udi: 'umb://document/772269d1ad5147458a9e3290ed432xx2',
                IsSelected: isSelected('772269d1ad5147458a9e3290ed432xx2'),
              },
            ],
          },
        ],
      },
      IsSuccess: true,
      ErrorMessage: null,
    };
  }

  const mockData =    (urlInfo.indexOf('LiteratureListing') !== -1
      && getLiteratureListingMockData())
    || (urlInfo.indexOf('ServiceListing') !== -1 && getServiceListingMockData())
    || getDefaultMockData();

  mockData.promise = new Promise((resolve) => {
    setTimeout(() => resolve({ data: mockData }), 150 + 500 * Math.random());
  });

  return mockData;
}
